import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'email_templates',
  namespace: 'emailTemplate',
  mountedUrl: '/email/templates',
  title: 'Templates',
  columns: [
    { attribute: 'type', label: 'code type' },
    { attribute: 'name' },
  ],
  defaultSort: ['type', 'asc'],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/template/containers/Listing.jsx